  <!--20-->
  <boi-form-numeric-input [labelName]="referenceDataLabels.InterestOnlyPartId"
    [isFieldDisabled]="isReadOnly" [isCurrency]="true" [contextualHelpName]="isKfi ? '' : referenceDataLabels.InterestOnlyPartId"
    [value]="interestOnlyPart" (valueChange)="interestOnlyPartChange.emit($event)"
    [propertyNames]="['InterestOnlyPart']" [fieldMaxLength]="7"></boi-form-numeric-input>

  <!--21-->
  <boi-form-numeric-input [labelName]="referenceDataLabels.RepaymentPartId"
    [isFieldDisabled]="true" [isCurrency]="true"
    [value]="repaymentPart">
  </boi-form-numeric-input>

  <!--22-->
  <boi-form-numeric-input [labelName]="referenceDataLabels.TotalLoan"
    [isFieldDisabled]="true" [isCurrency]="true"
    [value]="totalLoan" [cssClasses]="'form-input-bold'">
  </boi-form-numeric-input>
